<template>
  <div class="l-study-dialog">
    <div class="l-study-dialog-content">
      <div class="l-study-dialog-content-title">整看提示</div>
      <div class="l-study-dialog-close" @click="onClose"></div>
      <LPageWork>
        <template v-slot:body>
          <div class="content-body">
            <div class="l-learn-review">
              <div v-html="tip"></div>
            </div>
          </div>
        </template>
      </LPageWork>
      <div class="l-btns">
        <div class="l-btn-yellow" @click="onClose">知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
import LPageWork from '../../../l-page-work'

export default {
  name: 'l-learn-preview',
  data() {
    return {
      list: [],
    }
  },
  props: {
    tip: {
      type: String,
    },
  },
  components: {
    LPageWork,
  },
  methods: {
    //关闭弹框
    onClose() {
      this.$emit('close')
    },
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
}
</script>

<style lang="stylus">
@import './index.styl'
</style>
